import { Col, Flex, message, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  deleteEmailTemplateLayoutById,
  fetchEmailTemplateLayoutById,
} from "../../../lib/api/resources/emailTemplateLayouts";
import { EmailTemplateLayoutDetailCard } from "./components/EmailTemplateLayoutDetailCard";
import { EmailTemplateLayoutPreview } from "./components/EmailTemplateLayoutPreview";

export const EmailTemplateLayoutDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const { data, isLoading } = useQuery({
    queryKey: ["emailTemplateLayout", id],
    queryFn: () => fetchEmailTemplateLayoutById(id),
  });

  const deleteTemplateLayoutMutation = useMutation({
    mutationFn: () => deleteEmailTemplateLayoutById(id),
    onSuccess: () => {
      navigate(`/email-templates/layouts`);
      message.success("Email Template Layout succesvol verwijderd");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het verwijderen van de Email Template Layout",
      ),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <EmailTemplateLayoutDetailCard
              deleteMutation={deleteTemplateLayoutMutation}
              template={data}
              isLoading={isLoading}
            />
          </Flex>
        </Col>

        <Col span={12}>
          <EmailTemplateLayoutPreview title="Email preview" html={data?.html} />
        </Col>
      </Row>
    </div>
  );
};
